import { render } from "./ResourceCarousel.vue?vue&type=template&id=25399452"
import script from "./ResourceCarousel.vue?vue&type=script&lang=js"
export * from "./ResourceCarousel.vue?vue&type=script&lang=js"

import "./ResourceCarousel.vue?vue&type=style&index=0&id=25399452&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__